export type WorkbookMapping = { code: string; KCC_NUMBER: string };
export function parseSecurityWorkbook(table: unknown[][]) {
    const normalize = (value: unknown) => String(value ?? '').trim();
    const header = table.findIndex(row => row.some(cell => /^(bursa|stk|stock)\s*code$/i.test(normalize(cell))) && row.some(cell => /^kcc\s*(code|number)$/i.test(normalize(cell))));
    if (header < 0) throw new Error('The workbook must contain Bursa Code (or Stk Code) and KCC Code columns.');
    const columns = table[header].map(normalize);
    const codeIndex = columns.findIndex(cell => /^(bursa|stk|stock)\s*code$/i.test(cell));
    const kccIndex = columns.findIndex(cell => /^kcc\s*(code|number)$/i.test(cell));
    const rows: WorkbookMapping[] = [], skipped: { row: number; code: string; reason: string }[] = [];
    const codes = new Set<string>(), numbers = new Set<string>();
    for (let i = header + 1; i < table.length; i++) {
        const code = normalize(table[i][codeIndex]), kcc = normalize(table[i][kccIndex]);
        if (!code && !kcc) continue;
        if (!kcc || /^unquoted$/i.test(kcc)) { skipped.push({ row: i + 1, code, reason: 'No quoted KCC number' }); continue; }
        if (!/^[A-Za-z0-9._-]+$/.test(code) || !/^\d{1,10}$/.test(kcc) || Number(kcc) < 1) throw new Error(`Invalid stock code or KCC number on row ${i + 1}.`);
        const canonical = kcc.replace(/^0+(?=\d)/, '');
        if (codes.has(code) || numbers.has(canonical)) throw new Error(`Duplicate stock code or KCC number on row ${i + 1}.`);
        codes.add(code); numbers.add(canonical); rows.push({ code, KCC_NUMBER: kcc });
    }
    if (!rows.length || rows.length > 300) throw new Error('Provide between 1 and 300 valid security mappings.');
    return { rows, skipped };
}
